import { SVGProps } from '@components/Icon/types';

export const TimeTracking = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(3.5, 2)">
      <path
        d="M8.53381 6.62036C8.97123 6.6206 9.31144 6.98292 9.31163 7.41144V11.2589L11.7369 13.1452C12.0785 13.4087 12.1424 13.8997 11.8901 14.2457C11.6658 14.5529 11.2619 14.6492 10.9314 14.4892L10.9252 14.4865L10.9199 14.483L10.8076 14.4143L10.8005 14.4098L10.7951 14.4054L8.05 12.2899L8.03931 12.2828L8.03397 12.2783C7.85125 12.1271 7.75522 11.8895 7.75509 11.6522V7.41144C7.75528 6.9828 8.09614 6.62036 8.53381 6.62036Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99412 0.000102839C10.2531 -0.00437873 10.4957 0.137969 10.6258 0.357738C10.7447 0.556103 10.7604 0.79838 10.6713 1.0079L10.6677 1.01771L10.6463 1.05695V1.06409L10.6267 1.0962C10.5121 1.29053 10.3105 1.42283 10.0886 1.44937L10.0788 1.45026L10.0004 1.45383H9.17353V3.12249L9.21541 3.12695C13.5102 3.52346 16.8928 7.14426 16.893 11.5452C16.8929 16.2046 13.1013 20 8.44649 20C3.79159 20 0.000100129 16.2047 0 11.5452C0.000185345 7.1445 3.38307 3.52379 7.67757 3.12695L7.71945 3.12249V1.45383H6.89886C6.67222 1.45779 6.45764 1.34985 6.32061 1.17557L6.31616 1.16933L6.27161 1.10511L6.24666 1.06944V1.05695L6.22617 1.01771L6.22082 1.00879L6.22171 1.0079C6.13256 0.798395 6.14742 0.555238 6.26626 0.356846C6.39658 0.136563 6.64008 -0.00352732 6.89886 0.000994696L9.99412 0.000102839ZM8.44649 4.54501C4.57357 4.54501 1.45338 7.66848 1.45319 11.5452C1.45329 15.422 4.5735 18.5463 8.44649 18.5463L8.80734 18.5365C12.5114 18.3495 15.4397 15.3008 15.4398 11.5452C15.4396 7.78967 12.5114 4.74088 8.80734 4.55393L8.44649 4.54501Z"
        fill={fill}
      />
      <path
        d="M14.6174 3.07879C14.8084 3.07923 14.9966 3.1641 15.1395 3.30711L16.7798 4.94902L16.844 5.02037C16.9819 5.19547 17.0323 5.42693 16.9794 5.65002L16.9785 5.65359C16.9103 5.90897 16.7118 6.10683 16.4573 6.17532L16.4537 6.17711C16.2319 6.23027 16.0009 6.1811 15.8211 6.03887L15.8131 6.03262L15.7534 5.97733L15.7481 5.97287L14.0971 4.32115L14.0401 4.25515L14.0329 4.24713C13.9005 4.07214 13.8537 3.84403 13.91 3.63085L13.9412 3.53721C14.0486 3.26193 14.3138 3.08557 14.6147 3.07879H14.6174Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'time-tracking';
